import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import cx from "classnames";
import PropTypes from "prop-types";
import { useDropzone } from 'react-dropzone';
import { CSVLink } from "react-csv";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { Table, TableBody, TableCell, TableHead, TableRow, FormControl, Select, MenuItem } from "@material-ui/core";

import Close from "@material-ui/icons/Close";

import Button from "components/CustomButtons/Button.js";
import Clearfix from "components/Clearfix/Clearfix";
import CustomInput from "components/CustomInput/CustomInput.js";
import styles from "assets/jss/material-dashboard-pro-react/components/tableStyle";
import selectStyles from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";
import customStyles from 'views/component/Styles.js';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileUpload, faFileDownload } from '@fortawesome/free-solid-svg-icons'

const useStyles = makeStyles(styles);
const useCustomStyles = makeStyles(customStyles);
const useSelectStyles = makeStyles(selectStyles);

export default function SimpleTable(props) {
  const classes = { ...useStyles(), ...useCustomStyles(), ...useSelectStyles() };
  const { domain, tableName, params, tableHeaderColor, hover, select, selected, select2, striped, onRowClick, onChange,
    onRemove, onSave, selectForm, selectFilter, insertAttr, readOnly, nullIfEmpty, data, onAdd, droppable } = props;

  const [selectedIndex, setSelectedIndex] = useState(selected);
  const [selectedIndex2, setSelectedIndex2] = useState();
  const [tableData, setTableData] = useState({});
  const [originalData, setOriginalData] = useState({});
  const [removedList, setRemovedList] = useState([]);

  const [editMode, setEditMode] = useState(false);
  const [selectForms, setSelectForms] = useState({});
  const [drop, showDrop] = useState(false);

  const mounted = useRef(true);
  useEffect(() => {
    return () => { mounted.current = false }
  }, []);

  const loadList = function () {
    axios.get(domain + '/list/' + tableName, { params: params }).then(response => {
      if (mounted.current) {
        setTableData(response.data);
        setRemovedList([]);
      }
    });
  }
  useEffect(() => {
    if (data) {
      setTableData(data);
      setRemovedList([]);
    }
  }, [data]);
  useEffect(() => {
    if (tableName && !data && !tableData.cols && params && Object.keys(params).length) {
      loadList();
    } else if (props.insertData && props.insertData.length !== 0) {
      let temp = { ...tableData };
      temp.data = [...temp.data, ...props.insertData.map(item => ({ ...item, insert: true }))];
      setTableData(temp);
      setEditMode(true)
    }
  }, [tableName, params, props.insertData]);



  useEffect(() => {
    if (selectForm) {
      let temp = {};
      Object.keys(selectForm).filter(key => !selectForm[key].table).forEach(key => temp[key] = selectForm[key]);

      const reqList = Object.keys(selectForm).filter(key => selectForm[key].table);
      axios.all(reqList.map(colName =>
        axios.get(domain + '/list/' + selectForm[colName].table)
      )).then(axios.spread((...responseList) => {
        if (mounted.current) {
          reqList.forEach((colName, index) => {
            const setting = selectForm[colName];
            temp[colName] = responseList[index].data.data.map(item => ({ label: item[setting.label], value: item[setting.value] }));
          });
          setSelectForms(temp);
        }
      }));
    }
  }, [selectForm]);

  useEffect(() => {
    setSelectedIndex(selected);
  }, [selected]);

  const handleAdd = function () {
    let temp = { insert: true, ...insertAttr };
    tableData.cols.forEach(item => {
      if (!temp[item.colName]) {
        item.type === 'number' ? temp[item.colName] = 0 : temp[item.colName] = '';
      }
    });
    if (onAdd) {
      temp = onAdd(tableData.data, temp);
    }
    setTableData({ data: [...tableData.data, temp], cols: tableData.cols });
  }
  const handleSave = function () {
    const data = [...removedList, ...tableData.data.filter(data => data.insert || data.update)].map(item => {
      Object.entries(item).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          item[key] = value.join(',');
        }
      });
      return item;
    });
    axios.post(domain + '/listedit/' + tableName, data)
      .then(response => {
        if (mounted.current) {
          setEditMode(false);
          loadList();
          if (onSave) {
            onSave(tableData.data);
          }
        }
      });
  }
  const handleRemoveClick = function (row) {
    let tempData = { ...tableData };
    tempData.data[row].delete = true;
    setRemovedList([...removedList, tempData.data[row]]);
    setTableData({ data: tempData.data.filter(item => item.delete !== true), cols: tableData.cols });
    if (onRemove) {
      onRemove(row);
    }
  }
  const handleValueChange = function (row, colName, value) {
    let tempData = { ...tableData };
    tempData.data[row][colName] = value;
    tempData.data[row].update = true;
    setTableData(tempData);
    if (onChange) {
      onChange(row, colName, value, tempData.data);
    }
  }
  const drawSelectForm = function (row, rowIndex, colInfo) {
    const itemList = (selectFilter && selectFilter[colInfo.colName])
      ? selectFilter[colInfo.colName](row, selectForms[colInfo.colName])
      : selectForms[colInfo.colName];
    return <FormControl fullWidth className={classes.selectFormControlInfo}>
      <Select MenuProps={{ className: classes.selectMenu }} classes={{ select: classes.select }}
        value={row[colInfo.colName]}
        onChange={e => { handleValueChange(rowIndex, colInfo.colName, e.target.value) }}
        inputProps={{ id: colInfo.colName }}>
        {itemList.map((item) => {
          return <MenuItem classes={{ root: classes.selectMenuItemInfo, selected: classes.selectMenuItemSelectedInfo }}
            value={item.value} key={item.value}>
            {item.label}
            {item.image ? <img src={item.image.src} width={item.image.width} style={{ marginLeft: 10 }} /> : ''}
          </MenuItem>;
        })}
      </Select>
    </FormControl>

  }

  const drawEditList = function () {
    return tableData.data.map((row, rowIndex) => {
      const tableRowClasses = cx({
        [classes.tableRowBody]: true,
      });
      const cols = tableData.cols.filter(item => item.ordr !== 0);
      return (
        <TableRow key={rowIndex} className={classes.tableRow + " " + tableRowClasses}>
          {cols.map(colInfo =>
            <TableCell className={classes.editTableCell} key={colInfo.colName}>
              {selectForms[colInfo.colName] ?
                drawSelectForm(row, rowIndex, colInfo)
                :
                <FormControl fullWidth className={classes.formControlInfo}>
                  <CustomInput formControlProps={{ fullWidth: true }}
                    underlineColor="info" onTable
                    inputProps={{
                      type: colInfo.type, value: row[colInfo.colName],
                      step: colInfo.step ? colInfo.step : 1,
                      onChange: e => handleValueChange(rowIndex, colInfo.colName, e.target.value),
                      disabled: (colInfo.isFixed || colInfo.isKey) && row[colInfo.colName] && !row.insert
                    }}
                  />
                </FormControl>
              }
            </TableCell>
          )}
          <TableCell className={classes.editTableCell} key={rowIndex}>
            <Button className={classes.actionButton} key="key" color="danger" onClick={e => handleRemoveClick(rowIndex)}>
              <Close className={classes.icon} />
            </Button>
          </TableCell>
        </TableRow>
      );
    });
  }

  useEffect(() => {
    if (onRowClick && tableData.data) {
      onRowClick(tableData.data[selectedIndex], tableData.data[selectedIndex2]);
    }
  }, [selectedIndex, selectedIndex2]);

  const onListRowClick = function (rowIndex) {
    if (select2) {
      if (rowIndex === selectedIndex2) {
        setSelectedIndex2();
      } else if (rowIndex === selectedIndex) {
        setSelectedIndex();
      } else if (isNaN(selectedIndex)) {
        setSelectedIndex(rowIndex);
      } else if (isNaN(selectedIndex2)) {
        setSelectedIndex2(rowIndex);
      }
    } else {
      setSelectedIndex(rowIndex);
    }

  }

  const drawList = function () {
    return tableData.data.map((row, rowIndex) => {
      var rowColor = "";
      var rowColored = false;
      if (select && rowIndex === selectedIndex) {
        rowColor = select;
        rowColored = true;
      } else if (select2 && rowIndex === selectedIndex2) {
        rowColor = select2;
        rowColored = true;
      }
      const tableRowClasses = cx({
        [classes.tableRowBody]: true,
        [classes.tableRowHover]: hover || !!select,
        [classes[rowColor + "Row"]]: rowColored,
        [classes.tableStripedRow]: striped && rowIndex % 2 === 0
      });
      const cols = tableData.cols.filter(item => item.ordr !== 0).map(item => item.colName);
      return (
        <TableRow key={rowIndex} hover={hover || !!select} className={classes.tableRow + " " + tableRowClasses}>
          {cols.map(colName => {
            let value = row[colName];
            const columnInfo = tableData.cols.find(item => item.colName === colName);
            switch (columnInfo.type) {
              case 'array': value = Array.isArray(row[colName]) ? row[colName].join(',') : row[colName]; break;
              case 'json': value = JSON.parse(row[colName].value); break;
            }
            if (columnInfo.type === 'json') {
              return columnInfo.korName.split(',').map(cell => (
                <TableCell className={classes.tableCell} key={cell.split(':')[0]} onClick={(e) => { onListRowClick(rowIndex) }}>
                  {value[cell.split(':')[0]]}
                </TableCell>
              ))
            }
            return <TableCell className={classes.tableCell} key={colName} onClick={(e) => { onListRowClick(rowIndex) }}>
              {value}
            </TableCell>
          })}
        </TableRow>
      );
    });
  }

  const drawDrop = function () {
    return <div {...getRootProps({ className: 'dropzone' })} className={classes.dropzone} style={{ height: '200px' }}>
      <input {...getInputProps()} />
      <div className={classes.dropzoneText}>
        <div>파일을 드래그하여 업로드하거나<br /> 직접 입력해주세요</div>
        <Button color="info" onClick={e => { e.stopPropagation(); showDrop(false); }}>직접입력</Button>
      </div>
    </div>
  }

  const onDrop = function (acceptedFiles) {
    const cols = tableData.cols.filter(item => item.ordr !== 0).map(item => item.colName);
    acceptedFiles.forEach(file => {
      const reader = new FileReader()
      reader.onload = () => {
        let removed = [...tableData.data].map(item => { item.delete = true; return item; });
        setRemovedList([...removedList, ...removed]);

        let added = [];
        reader.result.match(/[^\r\n]+/g).forEach((line, index) => {
          if (index !== 0) {
            let temp = { ...params, insert: true };
            let tokens = line.split('","');
            tokens.forEach((token, index) => {
              temp[cols[index]] = token.replace(/"/g, "");
            })
            added.push(temp);
          }
        });

        setTableData({ data: added, cols: tableData.cols });
        if (added.length !== 0) {
          showDrop(false);
          setEditMode(true);
        }
      }
      reader.readAsText(file, 'euc-kr');
    });
  };

  const onDropRejected = function () {
    alert('CSV 파일만 입력 가능합니다');
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop, onDropRejected, accept: '.csv' });


  const getButtons = function () {
    if (readOnly || drop) {
      return ''
    } else if (editMode) {
      return (
        <div>
          <Button color="success" className={classes.right} size="sm" onClick={handleSave}>저장</Button>
          <Button color="danger" className={classes.right} size="sm"
            onClick={e => { setTableData(originalData); setEditMode(false) }}>취소</Button>
          <Button color="info" className={classes.right} size="sm" onClick={handleAdd}>추가</Button>
        </div>
      )
    } else {
      return (<>
        {droppable &&
          <>
            <CSVLink data={tableData.data} filename={tableName + '.csv'}
              headers={tableData.cols.filter(item => item.ordr !== 0).map(colInfo => ({ label: colInfo.korName, key: colInfo.colName }))}>
              <Button justIcon color="infoOutline" className={classes.right} size="sm" >
                <FontAwesomeIcon icon={faFileDownload} />
              </Button>
            </CSVLink>
            <Button justIcon color="infoOutline" className={classes.right} size="sm"
              onClick={e => { setOriginalData(tableData); showDrop(true); }}>
              <FontAwesomeIcon icon={faFileUpload} />
            </Button>
          </>}
        <Button color="info" className={classes.right} size="sm"
          onClick={e => { setOriginalData(tableData); setEditMode(true) }}>수정
        </Button>
      </>
      )
    }
  }
  return (!tableData.cols || tableData.cols.length === 0) || (nullIfEmpty && (!tableData.data.data || tableData.data.data.length === 0)) ? null : (
    <>
      {getButtons()}
      <Clearfix />
      {drop ? drawDrop() :
        <Table className={classes.table}>
          <TableHead className={classes[tableHeaderColor]}>
            <TableRow className={classes.tableRow + " " + classes.tableRowHead + " " + classes.tableHeadFontSize}>
              {tableData.cols.filter(item => item.ordr !== 0).map(item => {
                const tableCellClasses = classes.tableHeadCell + " " + classes.tableCell;
                if (item.type === 'json') {
                  return item.korName.split(',').map(cell => (
                    <TableCell className={tableCellClasses} key={cell.split(':')[0]}>
                      {cell.split(':')[1]}
                    </TableCell>
                  ))
                }
                return (
                  <TableCell className={tableCellClasses} key={item.colName}>
                    {item.korName}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData.data.length === 0 ? (
              <TableRow><TableCell className={classes.tableCell} colSpan={tableData.cols.length}>데이터가 없습니다</TableCell></TableRow>
            ) : null}
            {editMode ? drawEditList() : drawList()}
          </TableBody>
        </Table>}
    </>
  );
}

SimpleTable.defaultProps = {
  tableHeaderColor: "gray",
  hover: false,
  striped: false,
  readOnly: false,
  nullIfEmpty: false,
  droppable: false,
};

const colors = [
  "warning",
  "primary",
  "danger",
  "success",
  "info",
  "rose",
  "gray"
];
SimpleTable.propTypes = {
  tableHeaderColor: PropTypes.oneOf(colors),
  hover: PropTypes.bool,
  select: PropTypes.oneOf(colors),
  select2: PropTypes.oneOf(colors),
  selected: PropTypes.number,
  striped: PropTypes.bool,
  onRowClick: PropTypes.func,
  domain: PropTypes.string,
  tableName: PropTypes.string,
  params: PropTypes.object,
  selectForm: PropTypes.object,
  readOnly: PropTypes.bool,
  nullIfEmpty: PropTypes.bool,
  droppable: PropTypes.bool,
};
